import { FilterTypes } from "../../handlers/filter";
/**
 * Filters for minimal recipes (excludes boolean expressions)
 */
export const MINIMAL_RECIPE_FILTERS = {
    where: [
        {
            type: FilterTypes.EQ,
            value: false,
            field: "loadBoolExpr"
        }
    ]
};
/**
 * Filters for default/full recipes (includes preferred flag)
 */
export const DEFAULT_RECIPE_FILTERS = {
    where: [
        {
            type: FilterTypes.EQ,
            value: true,
            field: "fetchPreferred"
        }
    ]
};
//# sourceMappingURL=constants.js.map